import { render, staticRenderFns } from "./DateWidget.vue?vue&type=template&id=065d8abf&scoped=true&"
import script from "./DateWidget.vue?vue&type=script&lang=js&"
export * from "./DateWidget.vue?vue&type=script&lang=js&"
import style0 from "./DateWidget.vue?vue&type=style&index=0&id=065d8abf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065d8abf",
  null
  
)

export default component.exports